import { addToChainAfter, addToStartOfChain, ApiHandler, ApiHandlerDiscreteParameter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    createHandlerChainRunnerOptionalParameter,
    Handler,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { AddCartLinesApiParameter } from "@insite/client-framework/Services/CartService";
import { chain, LoadCart, RequestDataFromApi } from "@insite/client-framework/Store/Pages/Cart/Handlers/AddLinesToCart";
import { CartLineCollectionModel } from "@insite/client-framework/Types/ApiModels";
import { addCartModifiedToLocalStorage } from "@NA/Utils/Utility";


type HandlerType = ApiHandlerDiscreteParameter<
    {
        apiParameter: AddCartLinesApiParameter;
        onSuccess?: () => void;
    },
    AddCartLinesApiParameter,
    CartLineCollectionModel
>;

export const PushAddToCartCompleteInLocalStorage: HandlerType = props => {    
    addCartModifiedToLocalStorage();
};

addToStartOfChain(chain, PushAddToCartCompleteInLocalStorage); //  RequestDataFromApi,

